export const billingRoutes = {
  path: '/billing',
  children: [
    {
      name: 'billing',
      path: '',
      component: () => import('pages/Billing/Billing/index.vue'),
      meta: {
        title: 'Billing',
      },
    },
    {
      name: 'creditApplicationBilling',
      path: 'credit-application',
      component: () => import('pages/Billing/CreditApplication/index.vue'),
      meta: {
        title: 'Credit Application Billing',
      },
    },
    {
      name: 'achBilling',
      path: 'ach',
      component: () => import('pages/Billing/Arch/index.vue'),
      meta: {
        title: 'ACH Billing',
      },
    },
    {
      name: 'creditCardBilling',
      path: 'credit-card',
      component: () => import('pages/Billing/CreditCard/index.vue'),
      meta: {
        title: 'Credit Card',
      },
    },
  ],
}
